import {VGNav} from "vgnav";

window.VegasListener = {
	onReady: () => {
		Vegas.bg();
		Vegas.enablePlugins();
		Vegas.other();
		Vegas.ScrollToTop.init($(window));
		Vegas.ScrollHeader.init($(window));
		Vegas.clone();
	},

	onLoad: () => {
		Vegas.preloader();
	},

	onClick: () => {},

	onScroll: ($self) => {
		Vegas.ScrollHeader.init($self);
		Vegas.ScrollToTop.setPosition($self);
	},

	onResize: ($self) => {
		Vegas.clone();
	},
};

window.Vegas = {
	log: function () {
		console.group('vegas studio');
		console.log("%cvegas app was initialization","color: green;");
		console.log('https://vegas-dev.com/');
		console.groupEnd();
	},

	preloader: function () {

	},

	clone: function () {
		if (window.innerWidth < 1199) {
			let $obj_filters_clone = $('#sidebar-filters');
			if ($obj_filters_clone.length) {
				$obj_filters_clone.clone(true).detach();
				$('.catalog-sidebar--clone-filters').append($obj_filters_clone)
			}
		}
	},

	enablePlugins: function () {
		// vgnav
		new VGNav({
			expand: 'xl',
			flip: true,
			toggle: '<i class="icon icon-chevron-down"></i>'
		});

		// tooltip
		$('[data-toggle=tooltip]').tooltip();

		// Range slider
		let $sliders = $('#range-price, #range-weight');
		if ($sliders.length) {
			$sliders.each(function () {
				let $slider = $(this);

				$slider.ionRangeSlider({
					skin: "round",
					onChange: function (data) {
						$slider.closest('.catalog-filters__item--range').find('[data-number=from]').val(data.from);
						$slider.closest('.catalog-filters__item--range').find('[data-number=to]').val(data.to);
					}
				});
			});
		}


		const $inputRange = $('.range-input');
		$inputRange.on('input keyup', function () {
			let $self = $(this),
				type = $self.data('number'),
				$range = $self.closest('.catalog-filters__item--range').find('.range-slider-filters'),
				$slider = $range.data("ionRangeSlider"),
				val = parseInt($self.val()) || null,
				min = parseInt($self.attr('min')) || null,
				max = parseInt($self.attr('max')) || null;

			if (min && val < min) {
				val = min;
			}

			if (max && val > max) {
				val = max;
			}

			if (val !== null) {
				if (type === 'from') {
					$slider.update({
						from: val
					});
				}

				if (type === 'to') {
					$slider.update({
						to: val
					});
				}
			}

			return false
		});

		$inputRange.on('blur', function () {

			return false
		});
	},

	bg: function () {
		let $bg = $('[data-bg]');
		if ($bg.length) {
			$bg.each(function () {
				let $self = $(this),
					bg = $self.data('bg'),
					repeat = $self.data('repeat') || 'no-repeat',
					position = $self.data('position') || 'center',
					size = $self.data('size') || 'cover',
					attachment = $self.data('attachment') || 'inherit';

				$self.css({
					'background-image': 'url(' + bg + ')',
					'background-position': position,
					'background-repeat': repeat,
					'background-size': size,
					'background-attachment': attachment
				});
			});
		}
	},

	other: function () {
		let $pageText = $('.vg-page-default'),
			$table = $pageText.find('table');

		$table.addClass('table table-hover table-striped');
		$table.wrap('<div class="table-responsive"></div>');
		$pageText.find('br').after('<span class="mb-5 d-block"></span>');
		$pageText.find('img').addClass('img-fluid');

		$('.getSearch').click(function () {
			$('.vg-search').slideToggle(function () {
				$(this).find('#query').focus()
			});

			return false;
		});

		$('.form-close-search-button').click(function () {
			$('.vg-search').slideToggle();

			return false;
		});
	},

	ScrollHeader: {
		lastScrollTop: 0,
		body: $('body'),
		stickyArea: $('.sticky-area'),
		height: {
			window: window.innerHeight,
			wrapper: $('.vg-wrapper').height(),
			sticky: $('.vg-header-wrapper').height()
		},

		init: function ($window) {
			let $sticky = $('.vg-header-wrapper'),
				scroll = $window.scrollTop();

			if ((this.height.window + this.height.sticky + 50) > this.height.wrapper) return;

			if (scroll > 0) {
				this.body.addClass('header--is-scroll');
				$sticky.addClass('scroll');

				if (scroll > this.lastScrollTop) {
					$sticky.removeClass('fixed');
					this.body.removeClass('header--is-fixed');
					this.stickyArea.removeClass('fixed');
				} else {
					$sticky.addClass('fixed');
					this.body.addClass('header--is-fixed');
					this.stickyArea.addClass('fixed');
				}

				this.lastScrollTop = scroll;
			} else if (scroll === 0) {
				$sticky.removeClass('scroll').removeClass('fixed');
				this.body.removeClass('header--is-scroll header--is-fixed');
			}

			// widgets-sticky scroll
			let $widgetsSticky = $('.widgets-sticky, .sticky-top, .sticky-area');
			if ($widgetsSticky.length) {
				if(this.body.hasClass('header--is-fixed')) {
					$widgetsSticky.css('top', 100);
				} else {
					$widgetsSticky.css('top', 16);
				}
			}
		},
	},

	ScrollToTop: {
		posActive: 400,
		btn: 'btn-scroll-to-top',

		init: function ($window) {
			let $layoutScrollToTop = $('#' + this.btn);

			if (!$layoutScrollToTop.length) {
				$('body').append('<div class="to-top" id="'+ this.btn +'"><span><i class="fal fa-chevron-up"></i></span></div>')

				this.setPosition($window);
			}

			let $btnScrollToTop = $('#' + this.btn + ' span');
			$btnScrollToTop.click(function () {
				window.scrollTo(0, 0);

				return false;
			});
		},

		setPosition: function ($window) {
			let $sticky = $('#' + this.btn ),
				scroll = $window.scrollTop();

			if (scroll >= this.posActive) {
				$sticky.addClass('is-active');
			} else {
				$sticky.removeClass('is-active');
			}
		}
	}
};
